var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstalled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4974 17.1667L16.6641 13H13.5391V3.625H11.4557V13H8.33073L12.4974 17.1667ZM21.8724 3.625H15.6224V5.69792H21.8724V20.3125H3.1224V5.69792H9.3724V3.625H3.1224C1.97656 3.625 1.03906 4.5625 1.03906 5.70833V20.2917C1.03906 21.4375 1.97656 22.375 3.1224 22.375H21.8724C23.0182 22.375 23.9557 21.4375 23.9557 20.2917V5.70833C23.9557 4.5625 23.0182 3.625 21.8724 3.625ZM12.4974 17.1667L16.6641 13H13.5391V3.625H11.4557V13H8.33073L12.4974 17.1667ZM21.8724 3.625H15.6224V5.69792H21.8724V20.3125H3.1224V5.69792H9.3724V3.625H3.1224C1.97656 3.625 1.03906 4.5625 1.03906 5.70833V20.2917C1.03906 21.4375 1.97656 22.375 3.1224 22.375H21.8724C23.0182 22.375 23.9557 21.4375 23.9557 20.2917V5.70833C23.9557 4.5625 23.0182 3.625 21.8724 3.625Z",
    fill: "skyblue"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstalled);
export default __webpack_public_path__ + "static/media/Installed.bb895d9afcf81273631a341dfc938925.svg";
export { ForwardRef as ReactComponent };